/**
 * Stable CSS class names for E2E — Rule tab create/edit modal.
 */
export const RTM = {
    modalRoot: 'rule-tab-modal',
    modalPaper: 'rule-tab-modal__paper',
    modalTitle: 'rule-tab-modal__title',
    modalCloseButton: 'rule-tab-modal-input--button-close',
    modalCloseIcon: 'rule-tab-modal__close-icon',

    titleLayout: 'rule-tab-modal__title-layout',
    titleText: 'rule-tab-modal__title-text',
    titleActions: 'rule-tab-modal__title-actions',
    importJsonButton: 'rule-tab-modal-input--button-import-json',
    importJsonIcon: 'rule-tab-modal__import-json-icon',
    exportJsonButton: 'rule-tab-modal-input--button-export-json',
    exportJsonIcon: 'rule-tab-modal__export-json-icon',

    form: 'rule-tab-modal__form',
    containerGrid: 'rule-tab-modal__container-grid',
    leftPanel: 'rule-tab-modal__left-panel',
    metaCard: 'rule-tab-modal__meta-card',
    templateSelectControl: 'rule-tab-modal-input__template-control',
    templateSelectLabel: 'rule-tab-modal-input__template-label',
    templateSelect: 'rule-tab-modal-input__template-select',
    templateSelectItem: 'rule-tab-modal-input__template-select-item',

    ruleKeyField: 'rule-tab-modal-input__rule-key',
    actionField: 'rule-tab-modal-input__action',

    divider: 'rule-tab-modal__divider',
    criteriaPanel: 'rule-tab-modal__criteria-panel',
    emptyCriteria: 'rule-tab-modal__empty-criteria',

    criteriaCard: 'rule-tab-modal__criteria-card',
    criteriaNameField: 'rule-tab-modal-input__criteria-name',
    operatorControl: 'rule-tab-modal-input__operator-control',
    operatorLabel: 'rule-tab-modal-input__operator-label',
    operatorSelect: 'rule-tab-modal-input__operator-select',
    operatorSelectItem: 'rule-tab-modal-input__operator-select-item',
    operatorHelpButton: 'rule-tab-modal-input--button-operator-help',
    operatorHelpIcon: 'rule-tab-modal__operator-help-icon',

    valueSingleField: 'rule-tab-modal-input__value-single',
    valueAField: 'rule-tab-modal-input__value-a',
    valueBField: 'rule-tab-modal-input__value-b',

    predefinedSelect: 'rule-tab-modal-input__predefined-select',
    predefinedSelectItem: 'rule-tab-modal-input__predefined-select-item',
    predefinedCheckbox: 'rule-tab-modal-input__predefined-checkbox',
    predefinedItemText: 'rule-tab-modal__predefined-item-text',
    selectAllWrap: 'rule-tab-modal__select-all-wrap',
    selectAllToggle: 'rule-tab-modal-input__select-all-toggle',

    jsonDialog: 'rule-tab-modal__json-dialog',
    jsonDialogContent: 'rule-tab-modal__json-dialog-content',
    jsonInput: 'rule-tab-modal-input__json-input',
    jsonDialogActions: 'rule-tab-modal__json-dialog-actions',
    jsonCancelButton: 'rule-tab-modal-input--button-json-cancel',
    jsonAcceptButton: 'rule-tab-modal-input--button-json-accept',
} as const;

export const ruleTabModalCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

